import {ClientActionTypes} from "../Actions/actionTypes";

const initialState = {
    clients: [],
    loading: false,
    error: null
};

export const clientReducer = (state = initialState, action) => {
    switch (action.type) {
        case ClientActionTypes.SET_DATA:
            return {...state, clients: action.payload};

        case ClientActionTypes.ADD_ONE:
            return {...state, clients: [...state.clients, action.payload]};

        case ClientActionTypes.UPDATE_ONE:
            return {
                ...state,
                clients: state.clients.map(client =>
                    client.id === action.payload.id ? action.payload : client
                )
            };

        case ClientActionTypes.DELETE_ONE:
            return {
                ...state,
                clients: state.clients.filter(client => client.id !== action.payload)
            };

        case ClientActionTypes.SET_LOADING:
            return {...state, loading: action.payload};

        case ClientActionTypes.SET_ERROR:
            return {...state, error: action.payload};

        default:
            return state;
    }
};